import { render, staticRenderFns } from "./PracticeAncillaryServicesPage.vue?vue&type=template&id=3c9fff20&scoped=true"
import script from "./PracticeAncillaryServicesPage.vue?vue&type=script&lang=js"
export * from "./PracticeAncillaryServicesPage.vue?vue&type=script&lang=js"
import style0 from "./PracticeAncillaryServicesPage.vue?vue&type=style&index=0&id=3c9fff20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9fff20",
  null
  
)

export default component.exports